import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "homePage"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "title",
  style: {
    "color": "white"
  }
}, "核心产品", -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", {
  class: "title"
}, "主要业务", -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", {
  class: "title"
}, "最新通知", -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", {
  class: "title"
}, null, -1);
import '../styles/HomePage.scss';
import MyDivider from "@/components/tool/MyDivider.vue";
import MyProduct from "@/components/home/MyProduct.vue";
import MyBusiness from "@/components/home/MyBusiness.vue";
import MyHotArticle from "@/components/home/MyHotArticle.vue";
// const createAiTools = () => {
//   const script = document.createElement('script');
//   script.src = 'https://chatapi.ccbox.top:9999/api/application/embed?protocol=https&host=chatapi.ccbox.top:9999&token=013c8b282bf2d1ff';
//   script.async = true;
//   script.defer = true;
//   document.body.appendChild(script);
// }
//
//
// onMounted(() => {
//   createAiTools();
// })
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(MyProduct), _createVNode(MyDivider), _hoisted_3, _createVNode(MyBusiness), _createVNode(MyDivider), _hoisted_4, _createVNode(MyHotArticle), _createVNode(MyDivider), _hoisted_5, _createVNode(MyDivider)]);
    };
  }
});